module.exports = __webpack_public_path__ + "static/media/spanish_flag.8413cd53.svg";